import { render, staticRenderFns } from "./SlyderF.vue?vue&type=template&id=1c7da9be&lang=pug&"
import script from "./SlyderF.vue?vue&type=script&lang=js&"
export * from "./SlyderF.vue?vue&type=script&lang=js&"
import style0 from "./SlyderF.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports